export const brandZIndexes = [
  'loadingSpinner',
  'onboarding',
  'modal',
  'dropdown',
  'wopiWindow',
  'appHeaderAvatar',
  'appNavigationOverlay',
  'appHeader',
  'uploadStatus',
  'languageSelector',
  'photoSearchBar',
  'moduleNavOverlay',
  'moduleNavOverlayShadow',
  'moduleNav',
  'fab',
  'appMainBottomToolbar',
  'appMainBottomToolbarContent',
  'timelineScrubber',
  'stickyTimelineHeader',
  'appOverlay',
  'appMainTopToolbar',
  'appMainDataTableHeader',
  'appMainDataTableBody',
] as const

export type BrandZIndex = (typeof brandZIndexes)[number]

export function getBrandZIndex(key: BrandZIndex): number {
  return brandZIndexes.length - brandZIndexes.findIndex(val => val === key)
}
